module.exports = __webpack_public_path__ + "static/media/approval.active.d01c39e8.svg";